import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TableSkeletonComponent } from '@dss-libs/shared/ui/common-components';
import { TTableSkeletonColumn } from '@dss-libs/shared/type/common-types';

@Component({
  selector: 'juno-libs-ui-user-management-skeleton',
  imports: [TableSkeletonComponent],
  templateUrl: './user-management-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserManagementSkeletonComponent {
  readonly tableColumns: TTableSkeletonColumn[] = [
    { lines: ['h-4 w-28'] },
    { lines: ['h-4 w-28'] },
    { lines: ['h-4 w-44'] },
    { lines: ['h-4 w-20'] },
    { minWidth: '4rem', cellClass: 'flex-none w-16 items-center px-3', lines: ['size-6'] },
  ];
}
